import { Stack, Typography } from '@mui/material';
import type { PartnerDetails } from '../../hooks/useGetPartnerInformation';

interface Props {
  leadAgents?: PartnerDetails['leadAgents'];
  pb?: number;
}
export const PartnerAgentsList = ({ leadAgents, pb }: Props) => (
  <Stack sx={{ pt: 3, gap: 1, pb }}>
    {leadAgents?.length ? (
      <>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
          }}
        >
          {`Lead${leadAgents.length > 1 ? 's' : ''}`}
        </Typography>
        {leadAgents.map(({ id, fullName }) => (
          <Typography variant="body2" key={id}>
            {fullName}
          </Typography>
        ))}
      </>
    ) : null}
  </Stack>
);
